export default __webpack_public_path__ + "static/media/banner-top-left.5edb1344.svg";